import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { ShopCategoryList } from '@domains/pdp-common';

interface CategoryProps {
  className?: string;
  categories: ShopCategoryList[];
  onClickCategoryItem: (category: ShopCategoryList) => void;
}

export const Category: React.FC<React.PropsWithChildren<CategoryProps>> = ({ className, categories, onClickCategoryItem }) => {
  return (
    <Container className={className}>
      <List>
        {categories.map((category, i) => {
          return (
            <Item key={i} onClick={() => onClickCategoryItem(category)}>
              {category.name}
            </Item>
          );
        })}
      </List>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 0 16px 0;
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;

  & ::-webkit-scrollbar {
    display: none;
  }
`;

const List = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  padding: 0 16px;
  height: 32px;
`;

const Item = styled.span`
  display: inline-block;
  color: ${vars.v3Color.purple400};
  background: ${vars.v3Color.purple50};
  border-radius: 6px;
  padding: 9px 12px 7px 12px;
  margin-right: 8px;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  opacity: 0.7;
`;
